import config from '../../generated/config';
import axios from 'axios';
import { path } from 'ramda';

const handleDocument = document => document.replace(/[^\d]/g, '');

export const getCustomerQualifyerData = async document => {
  const { customerQualifyer: uri } = config.api;

  const { customerQualifyer: authorization } = config.authorization;

  const method = 'get';
  const headers = {
    'Content-Type': 'application/json',
    Authorization: authorization
  };
  const url = `${uri}${handleDocument(document)}`;

  try {
    const response = await axios({
      url,
      method,
      headers
    });

    return { ...path(['data'], response), success: true };
  } catch (err) {
    return { ...err, success: false };
  }
};
